export const BulkActions = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2 9H5V7H2V9ZM2 13H5V11H2V13ZM2 5H5V3H2V5ZM6 9H14V7H6V9ZM6 13H14V11H6V13ZM6 3V5H14V3H6Z'
      fill='inherit'
    />
  </svg>
);

export const BulkDirectBuyIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1914_8416)'>
      <path
        d='M6.00004 6.66671C5.82323 6.66671 5.65366 6.73695 5.52864 6.86197C5.40362 6.987 5.33338 7.15657 5.33338 7.33338V10H6.66671V8.00004H8.66671V9.66671L11 7.33338L8.66671 5.00004V6.66671H6.00004ZM8.47138 0.928711L15.0714 7.52871C15.1964 7.65373 15.2666 7.82327 15.2666 8.00004C15.2666 8.17682 15.1964 8.34636 15.0714 8.47138L8.47138 15.0714C8.34636 15.1964 8.17682 15.2666 8.00004 15.2666C7.82327 15.2666 7.65373 15.1964 7.52871 15.0714L0.928711 8.47138C0.803731 8.34636 0.733521 8.17682 0.733521 8.00004C0.733521 7.82327 0.803731 7.65373 0.928711 7.52871L7.52871 0.928711C7.65373 0.803731 7.82327 0.733521 8.00004 0.733521C8.17682 0.733521 8.34636 0.803731 8.47138 0.928711Z'
        fill='inherit'
      />
    </g>
    <defs>
      <clipPath id='clip0_1914_8416'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const BulkIncludeIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1914_8423)'>
      <path
        d='M8.00004 14.6667C4.31804 14.6667 1.33337 11.682 1.33337 8.00004C1.33337 4.31804 4.31804 1.33337 8.00004 1.33337C11.682 1.33337 14.6667 4.31804 14.6667 8.00004C14.6667 11.682 11.682 14.6667 8.00004 14.6667ZM7.33337 7.33337H4.66671V8.66671H7.33337V11.3334H8.66671V8.66671H11.3334V7.33337H8.66671V4.66671H7.33337V7.33337Z'
        fill='inherit'
      />
    </g>
    <defs>
      <clipPath id='clip0_1914_8423'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const BulkExcludeIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1914_16594)'>
      <path
        d='M8.00004 14.6667C4.31804 14.6667 1.33337 11.682 1.33337 8.00004C1.33337 4.31804 4.31804 1.33337 8.00004 1.33337C11.682 1.33337 14.6667 4.31804 14.6667 8.00004C14.6667 11.682 11.682 14.6667 8.00004 14.6667ZM8.00004 7.05737L6.11471 5.17137L5.17137 6.11471L7.05737 8.00004L5.17137 9.88537L6.11471 10.8287L8.00004 8.94271L9.88537 10.8287L10.8287 9.88537L8.94271 8.00004L10.8287 6.11471L9.88537 5.17137L8.00004 7.05737Z'
        fill='inherit'
      />
    </g>
    <defs>
      <clipPath id='clip0_1914_16594'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const BulkUpdateBidIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2V3H6.4C5.55125 3 4.70856 3.2794 4.06276 3.81757C3.41164 4.36016 3 5.13939 3 6C3 6.86061 3.41164 7.63984 4.06276 8.18244C4.70856 8.7206 5.55125 9 6.4 9H9.6C10.0243 9 10.4025 9.14203 10.6569 9.35401C10.9059 9.56155 11 9.79974 11 10C11 10.2003 10.9059 10.4384 10.6569 10.646C10.4025 10.858 10.0243 11 9.6 11H8H6.41988C6.11016 10.9862 5.82511 10.8968 5.60025 10.758C5.3722 10.6173 5.23083 10.4422 5.16102 10.2771C4.94589 9.76848 4.35914 9.53052 3.85047 9.74565C3.34181 9.96078 3.10386 10.5475 3.31898 11.0562C3.56764 11.6441 4.00788 12.1254 4.54971 12.4599C5.09086 12.794 5.72276 12.9763 6.36404 12.9994C6.37602 12.9998 6.38801 13 6.4 13H7V14C7 14.5523 7.44772 15 8 15C8.55228 15 9 14.5523 9 14V13H9.6C10.4488 13 11.2914 12.7206 11.9372 12.1824C12.5884 11.6398 13 10.8606 13 10C13 9.13939 12.5884 8.36016 11.9372 7.81756C11.2914 7.2794 10.4488 7 9.6 7H6.4C5.97571 7 5.5975 6.85797 5.34313 6.64599C5.09407 6.43845 5 6.20026 5 6C5 5.79974 5.09407 5.56155 5.34313 5.35401C5.5975 5.14203 5.97571 5 6.4 5H8H9.58011C9.88983 5.01379 10.1749 5.10316 10.3997 5.24196C10.6278 5.38274 10.7692 5.55778 10.839 5.72286C11.0541 6.23152 11.6409 6.46948 12.1495 6.25435C12.6582 6.03922 12.8961 5.45247 12.681 4.94381C12.4324 4.35587 11.9921 3.87455 11.4503 3.54009C10.9091 3.20605 10.2772 3.02372 9.63596 3.00065C9.62398 3.00022 9.61199 3 9.6 3H9V2Z'
      fill='inherit'
    />
  </svg>
);

export const BulkResetCustomBidIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.00515 5.83358C3.00173 5.88868 3 5.94417 3 6C3 6.86061 3.41164 7.63984 4.06276 8.18244C4.64873 8.67074 5.39679 8.94601 6.16439 8.99282L3.00515 5.83358ZM8.17157 11H6.41988C6.11016 10.9862 5.82511 10.8968 5.60025 10.758C5.3722 10.6173 5.23083 10.4422 5.16102 10.2771C4.94589 9.76848 4.35914 9.53052 3.85047 9.74565C3.34181 9.96078 3.10386 10.5475 3.31898 11.0562C3.56764 11.6441 4.00788 12.1254 4.54971 12.4599C5.09086 12.794 5.72276 12.9763 6.36404 12.9994C6.37602 12.9998 6.38801 13 6.4 13H7V14C7 14.5523 7.44772 15 8 15C8.55228 15 9 14.5523 9 14V13H9.6C9.77903 13 9.95778 12.9876 10.1345 12.9629L8.17157 11ZM12.9949 10.1664C12.9983 10.1113 13 10.0558 13 10C13 9.13939 12.5884 8.36016 11.9372 7.81756C11.3513 7.32926 10.6032 7.05399 9.83561 7.00718L12.9949 10.1664ZM7.82843 5H9.58011C9.88983 5.01379 10.1749 5.10316 10.3997 5.24196C10.6278 5.38274 10.7692 5.55778 10.839 5.72286C11.0541 6.23152 11.6409 6.46948 12.1495 6.25435C12.6582 6.03922 12.8961 5.45247 12.681 4.94381C12.4324 4.35587 11.9921 3.87455 11.4503 3.54009C10.9091 3.20605 10.2772 3.02372 9.63596 3.00065C9.62398 3.00022 9.61199 3 9.6 3H9V2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2V3H6.4C6.22098 3 6.04222 3.01243 5.86553 3.0371L7.82843 5Z'
      fill='inherit'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.79289 1.79289C2.18342 1.40237 2.81658 1.40237 3.20711 1.79289L14.2071 12.7929C14.5976 13.1834 14.5976 13.8166 14.2071 14.2071C13.8166 14.5976 13.1834 14.5976 12.7929 14.2071L1.79289 3.20711C1.40237 2.81658 1.40237 2.18342 1.79289 1.79289Z'
      fill='inherit'
    />
  </svg>
);
